import { useLocale } from "@shared/hooks/language/languages";
import React, { Children, memo } from "react";
import { IntlProvider } from "react-intl";

const LanguageProvider = ({ messages, children }) => {
  const locale = useLocale();
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {Children.only(children)}
    </IntlProvider>
  );
};

export default memo(LanguageProvider);
